var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'btn-more-columns': _vm.type === 'kanban',
    'btn-more-columns-gantt': _vm.type === 'gantt',
  },on:{"click":_vm.loadMoreColumns}},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(" Mostrar más columnas... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }